module.exports = __webpack_public_path__ + "img/card-t3.46ec63a9.png";